// Ported from LC2's ExposureGlance.js (commons/components/HomeTabs/Today/Portfolio/Glance/
// ExposureGlance.js) — same ExposureCompColumns shape (commons/constants/tableColumns.js:
// property_name, resident_name, unit_name, lease_end_date [date], until_lease_end ["1 day" /
// "X days"], floor_plan, rent [currency], 120-day attained rent [currency], attained rent
// delta [percentage, red/green @ 0], market rent [currency], rent delta [percentage,
// red/green @ 0], last updated [date]) rendered straight off the raw "Exposure" glance rows
// (no client-side remapping — same as LC2), and same "no data" empty state (see
// ./GlanceEmptyState.js).
// SIMPLIFIED: table chrome rebuilt on ../components/DataTableShell.js instead of MUI X
// DataGrid Pro — see ./ConcessionGlance.js's header comment for why.
import React, {useMemo} from 'react';
import PropTypes from 'prop-types';

import DataTableShell from '../components/DataTableShell';
import GlanceCell from './GlanceCell';
import GlanceEmptyState from './GlanceEmptyState';

const COLUMN_SPECS = [
    {field: 'property_name', headerName: 'Property Name'},
    {field: 'resident_name', headerName: 'Resident Name'},
    {field: 'unit_name', headerName: 'Unit Name'},
    {field: 'lease_end_date', headerName: 'Lease Ends', format: 'date'},
    {field: 'until_lease_end', headerName: 'Lease Ends In', format: 'lease_days'},
    {field: 'floor_plan', headerName: 'Floor Plan'},
    {field: 'rent', headerName: 'In Place Rent', format: 'currency'},
    {field: 'property_attained_rent', headerName: '120 Day Attained Rent', format: 'currency'},
    {field: 'attained_rent_delta', headerName: 'Attained Rent Delta', format: 'percentage', color: 'red/green', colorValue: 0},
    {field: 'market_rent', headerName: 'Market Rent', format: 'currency'},
    {field: 'rent_delta', headerName: 'Rent Delta', format: 'percentage', color: 'red/green', colorValue: 0},
    {field: 'effective_at', headerName: 'Last Updated', format: 'date'}
];

const ExposureGlance = ({data}) => {
    const columns = useMemo(
        () =>
            COLUMN_SPECS.map((spec) => ({
                field: spec.field,
                headerName: spec.headerName,
                renderCell: (row) => <GlanceCell value={row[spec.field]} format={spec.format} color={spec.color} colorValue={spec.colorValue} />
            })),
        []
    );

    if (!data || data.length === 0) {
        return <GlanceEmptyState msg="No units found on public listing sites" type="Glance Metric" />;
    }

    return (
        <DataTableShell
            title="Exposure"
            description="All residents with leases expiring in the next 120 days. Compare your in place rents to current market prices for comparable units."
            columns={columns}
            rows={data}
            getRowId={(row) => row.id}
            searchPlaceholder="Search Exposure"
        />
    );
};

ExposureGlance.propTypes = {
    data: PropTypes.array
};

export default ExposureGlance;
